export default __webpack_public_path__ + "static/media/cook-service.7f307fed.jpg";